<script setup lang="ts">
import PrimeMenu from 'primevue/menu';
import { ref } from 'vue';

import eventBus from 'lib/event-bus';
import { useWangsVueConfig } from 'lib/plugins/WangsVue';

import { filterVisibleMenu } from './helpers';
import Menu, { MenuEmits, MenuProps } from './Menu.vue.d';
import MenuItem from '../menuitem/MenuItem.vue';

withDefaults(defineProps<MenuProps>(), { popup: true, model: () => [] });
const emit = defineEmits<MenuEmits>();

const { locale } = useWangsVueConfig('Menu');

const overlayId = +new Date();
const menu = ref<Menu>();
const toggle = (e: Event): void => {
  menu.value?.toggle(e);
};

const show = (e: Event): void => {
  menu.value?.show(e);
};

const hide = (event: { overlayId: number }): void => {
  // If another overlay is clicked, hide the current overlay
  if (menu.value && event.overlayId !== overlayId) menu.value?.hide();
};

const onHideMenu = (e: Event): void => {
  emit('blur', e);
  /*
   * Waiting for next tick will prevent the menu from
   * closing, so need to wait for 1 second
   */
  setTimeout(() => {
    eventBus.off('overlay:show', hide);
  }, 1000);
};

const onShowMenu = (e: Event): void => {
  eventBus.on('overlay:show', hide);
  eventBus.emit('overlay:show', { overlayId });
  emit('focus', e);
};

defineExpose({
  toggle,
  show,
  hide,
});
</script>

<template>
  <PrimeMenu
    v-bind="$props"
    ref="menu"
    :model="filterVisibleMenu($props.model, locale.noOptionLabel)"
    @blur="onHideMenu"
    @focus="onShowMenu"
  >
    <template #item="{ item, props, index }">
      <MenuItem :index="index" :item="item" :router-props="props" />
    </template>

    <template #start v-if="$slots['start']">
      <slot name="start" />
    </template>
  </PrimeMenu>
</template>
